import { useLocale } from "../../hooks/useLocale";
import { msg } from "../../locales/translate";
import { VBox } from "@ui/box/Box";
import Button from "@ui/button/Button";
import { Error } from "@ui/error/Error";
import { Form } from "@ui/form/Form";
import Panel from "@ui/panel/Panel";
import Spacer from "@ui/spacer/Spacer";
import Signal from "badmfck-signal";
import { useEffect, useState } from "react";
import { GD } from "src/GD";
import { IClient } from "src/services/ClientService";

export const S_ADD_CLIENT_POPUP = new Signal<{
	clientID: number;
} | null>("S_ADD_CLIENT_POPUP");

export const S_ADD_CLIENT_SUCCESS = new Signal<IClient>("S_ADD_CLIENT_SUCCESS");

export const AddClientPopup = () => {
	useLocale();
	const requestData = S_ADD_CLIENT_POPUP.use();
	const [busy, setBusy] = useState<boolean>();
	const [error, setError] = useState<IError>();
	const [form, setForm] = useState<IClient>();

	useEffect(() => {
		if (requestData) {
			loadGroup();
		}
	}, [requestData]);

	const loadGroup = async () => {
		if (requestData) {
			const res = await GD.REQ_CLIENT.request({
				clientID: requestData.clientID,
			});

			if (res?.error) {
				setError(res?.error);
			} else if (res?.data) {
				setForm(JSON.parse(JSON.stringify(res.data)));
			}
		}
	};

	if (!requestData) return null;

	const handleSubmit = async () => {
		if (form) {
			setError(undefined);
			setBusy(true);

			const res = await GD.REQ_CLIENT_SAVE.request(form);
			if (!res.error) {
				closePopup();
				S_ADD_CLIENT_SUCCESS.invoke(res.data);
			} else {
				setError(res.error);
			}

			setBusy(false);
		}
	};

	const closePopup = () => {
		S_ADD_CLIENT_POPUP.invoke(null);
		setError(undefined);
		setForm(undefined);
	};

	return (
		<Panel
			sx={{
				maxWidth: "1200px",
				height: "max-content",
				maxHeight: "90vh",
				padding: "0",
				minWidth: "500px",
			}}
			decorator="absolute"
			growContent
			busy={busy}
			label={requestData.clientID === 0 ? msg("addNewClient") : msg("editClient")}
			onClose={closePopup}>
			<VBox
				gap="20px"
				sx={{
					overflow: "auto",
					flexGrow: 1,
					// padding: "20px 20px",
					// backgroundColor: "#EEF0F2",
				}}>
				<Form
					data={form}
					decorator={[
						{
							// test_user_name: "",
							// test_user_password: "",
							// risk: "low,medium,high"

							direction: "column",
							fields: [
								{
									name: "country",
									label: msg("country"),
								},
								{
									name: "name",
									label: msg("clientName"),
								},
								{
									name: "registration_number",
									label: msg("companyRegNumber"),
								},
							],
						},
					]}
				/>
			</VBox>

			<Spacer size="20px"/>

			<VBox sx={{ gap: "12px" }}>
				<Error error={error} />
				<Button
					title={msg("submit_155f816c")}
					onClick={() => {
						handleSubmit();
					}}
				/>
			</VBox>
		</Panel>
	);
};
